import React, { useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import API from "../config/api.js";

export default function TemplateCard({ template, onUse }) {
  const location = useLocation();

  const [isFavorite, setIsFavorite] = useState(
    template.idtemplatefavorite !== null
  );

  const [isUsed, setIsUsed] = useState(template.idtemplateused !== null);

  const idTemplate = template.idtemplate;

  const requestType = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get("type");
  }, [location.search]);

  const idimages = Array.isArray(template.idimages) ? template.idimages : [];

  const canAccessCanva = true;

  const getTemplateImageUrl = (path) => {
    if (!path) return "/assets/img/260x325.png";
    return `${API.baseUrl}/${path.replace("original.jpg", "260x325.jpg")}`;
  };

  const images = useMemo(() => {
    const list = [];

    list.push(getTemplateImageUrl(template.image));

    if (template.type === "template" || template.type === "images") {
      if (template.image2) {
        list.push(getTemplateImageUrl(template.image2));
      }

      if (template.image3) {
        list.push(getTemplateImageUrl(template.image3));
      }
    }

    return list;
  }, [template]);

  const handleUsed = async () => {
    const next = !isUsed;
    setIsUsed(next);

    try {
      const formData = new FormData();
      formData.append("idtemplate", idTemplate);

      const res = await fetch(`${API.templates}?used`, {
        method: "POST",
        credentials: "include",
        body: formData,
      });

      const status = await res.json();
      setIsUsed(status === true);
    } catch (err) {
      setIsUsed(!next);
      console.error("Erro ao marcar template como usado:", err);
    }
  };

  const handleFavorite = async () => {
    const next = !isFavorite;
    setIsFavorite(next);

    try {
      const formData = new FormData();
      formData.append("idtemplate", idTemplate);

      const res = await fetch(`${API.templates}?favorite`, {
        method: "POST",
        credentials: "include",
        body: formData,
      });

      const status = await res.json();
      setIsFavorite(status === true);
    } catch (err) {
      setIsFavorite(!next);
      console.error("Erro ao favoritar template:", err);
    }
  };

  return (
    <div
      className={`card h-100 w-100 suggested template template-${idTemplate} rounded-4 animate__animated animate__fadeIn animate__slow`}
      data-idimages={idimages.join(",")}
      data-iddraft=""
    >
      <div
        id={`carousel-template-${idTemplate}`}
        className="carousel slide"
        data-bs-interval="500"
        onMouseEnter={(e) => {
          if (window.bootstrap?.Carousel) {
            const instance = window.bootstrap.Carousel.getOrCreateInstance(
              e.currentTarget
            );
            instance.cycle();
          }
        }}
        onMouseLeave={(e) => {
          if (window.bootstrap?.Carousel) {
            const instance = window.bootstrap.Carousel.getOrCreateInstance(
              e.currentTarget
            );
            instance.pause();
          }
        }}
      >
        <div className="carousel-inner">
          {images.map((image, index) => (
            <div
              key={`${idTemplate}-${index}`}
              className={`carousel-item ${index === 0 ? "active" : ""}`}
            >
              <img
                src={image}
                alt=""
                onError={(e) => {
                  e.currentTarget.src = "/assets/img/260x325.png";
                }}
                className="img-fluid w-100 bg-loading rounded-3"
                width="260"
                height="325"
                style={{ objectFit: "cover" }}
              />
            </div>
          ))}
        </div>

        {(template.type === "template" || template.type === "images") &&
          images.length > 1 && (
            <>
              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target={`#carousel-template-${idTemplate}`}
                data-bs-slide="prev"
              >
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
              </button>

              <button
                className="carousel-control-next"
                type="button"
                data-bs-target={`#carousel-template-${idTemplate}`}
                data-bs-slide="next"
              >
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
              </button>
            </>
          )}

        <div
          style={{ zIndex: 3 }}
          className="position-absolute top-0 end-0 p-2 text-white scheduled-date-time"
        ></div>

        <div
          style={{ zIndex: 4 }}
          className="position-absolute top-0 start-0 end-0 m-1 card-actions"
        >
          <div className="mt-2 px-2 py-1 action-buttons">
     

            <div className="dropup dropend d-inline-block z-3 position-relative">
              <button
                className="btn text-white"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <img
                  src="/assets/img/dots.png"
                  width="24"
                  height="24"
                  alt="menu"
                />
              </button>

              <ul className="dropdown-menu dropdown-menu-end">
                <li>
                  <button
                    type="button"
                    className="dropdown-item btn-template-used"
                    onClick={handleUsed}
                  >
                    {isUsed ? (
                      <>
                        <i className="fi fi-rr-checkbox me-2"></i>
                        Mark As Used
                      </>
                    ) : (
                      <>
                        <i className="fi fi-rr-square me-2"></i>
                        Mark As Used
                      </>
                    )}
                  </button>
                </li>

                <li>
                  <button
                    type="button"
                    className="dropdown-item btn-template-favorite"
                    onClick={handleFavorite}
                  >
                    {isFavorite ? (
                      <>
                        <i className="fi fi-sr-heart me-2"></i>
                        Favorite
                      </>
                    ) : (
                      <>
                        <i className="fi fi-rr-heart me-2"></i>
                        Favorite
                      </>
                    )}
                  </button>
                </li>
              </ul>
            </div>

            {canAccessCanva && template.url ? (
              <a href={template.url} target="_blank" rel="noreferrer">
                <img
                  src="/assets/img/canva-icon.webp"
                  className="rounded-circle align-bottom ms-1"
                  width="24"
                  height="24"
                  alt="Canva"
                />
              </a>
            ) : null}
          </div>

          {canAccessCanva && template.url ? (
            <div
              className="mt-2 px-2 py-1 action-buttons-canva"
              style={{ display: "none" }}
            >
              <a href={template.url} target="_blank" rel="noreferrer">
                <img
                  src="/assets/img/canva-icon.webp"
                  className="rounded-circle align-bottom ms-1"
                  width="24"
                  height="24"
                  alt="Canva"
                />
              </a>
            </div>
          ) : null}
        </div>

        <div
          style={{ zIndex: 4 }}
          className="position-absolute bottom-0 start-0 end-0 p-2 m-1"
        >
          <p className="card-text caption-content text-white">
            {template.caption}
          </p>
        </div>
      </div>
    </div>
  );
}